// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.name-lenght {
  overflow: hidden;
  max-width: 20ch;
}

.banner {
  width: 100vw;
  height: 100px;
  object-fit: cover;
  object-position: center;
}

.card-content {
  padding-top: 4px;
}`, "",{"version":3,"sources":["webpack://./src/app/public-events/public-events.page.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,eAAA;AACJ;;AAEA;EACI,YAAA;EACA,aAAA;EACA,iBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ","sourcesContent":[".name-lenght {\n    overflow: hidden;\n    max-width: 20ch;\n}\n\n.banner {\n    width: 100vw;\n    height: 100px;\n    object-fit: cover;\n    object-position: center;\n}\n\n.card-content {\n    padding-top: 4px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
